document.addEventListener('DOMContentLoaded', () => {
  const data = window.PostPurchaseSurveyData || {};
  const params = new URLSearchParams(window.location.search);
  let order = (params.get('order') || '').trim();
  let email = (params.get('email') || '').trim();

  const loadingEl = document.getElementById('pps-loading');
  const errorEl = document.getElementById('pps-error');
  const surveyEl = document.getElementById('pps-survey');
  const footerEl = document.getElementById('pps-footer');
  const productListEl = document.getElementById('pps-product-list');
  const submitBtn = document.getElementById('pps-submit-btn');
  const validationMsg = document.getElementById('pps-validation-msg');
  const cardTemplate = document.getElementById('pps-card-template');

  if (!loadingEl) return;

  const hideAll = () => {
    [loadingEl, errorEl, surveyEl, footerEl].forEach(el => {
      if (el) el.classList.add('tw-hidden');
    });
  };

  const showError = () => {
    hideAll();
    if (errorEl) errorEl.classList.remove('tw-hidden');
  };

  const showSurvey = () => {
    hideAll();
    if (surveyEl) surveyEl.classList.remove('tw-hidden');
    if (footerEl) footerEl.classList.remove('tw-hidden');
  };

  if (
    !errorEl ||
    !surveyEl ||
    !footerEl ||
    !productListEl ||
    !submitBtn ||
    !validationMsg ||
    !cardTemplate
  ) {
    showError();
    return;
  }

  const parseItem = value => {
    const s = String(value).trim();
    const sep = s.lastIndexOf(':');
    if (sep <= 0) return null;
    const handle = s.slice(0, sep).trim();
    const variantId = s.slice(sep + 1).trim();
    return handle && /^\d+$/.test(variantId) ? { handle, variantId } : null;
  };

  let requests = params.getAll('item').map(parseItem).filter(Boolean);

  const SURVEY_COOKIE = 'pps_survey';
  const SURVEY_TTL = 2700;

  const readCookie = name => {
    const match = document.cookie.match(
      new RegExp('(?:^|; )' + name + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  };
  const writeCookie = (name, value, maxAgeSec) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSec}; Path=/; SameSite=Lax`;
  };

  if (requests.length) {
    writeCookie(
      SURVEY_COOKIE,
      JSON.stringify({
        order,
        email,
        items: requests.map(r => `${r.handle}:${r.variantId}`)
      }),
      SURVEY_TTL
    );
  } else {
    try {
      const saved = JSON.parse(readCookie(SURVEY_COOKIE) || '{}');
      if (saved && Array.isArray(saved.items) && saved.items.length) {
        requests = saved.items.map(parseItem).filter(Boolean);
        if (!order) order = String(saved.order || '').trim();
        if (!email) email = String(saved.email || '').trim();
      }
    } catch (_) {}
  }

  const debug = params.get('ppsdebug') === '1';
  const renderDebug = extra => {
    if (!debug) return;
    const panel = document.createElement('pre');
    panel.style.cssText =
      'position:fixed;z-index:99999;bottom:0;left:0;right:0;margin:0;padding:12px 16px;background:#332726;color:#fffcf5;font:12px/1.5 monospace;white-space:pre-wrap;';
    panel.textContent = [
      `[PPS debug]`,
      `order: ${order || '—'}`,
      `email: ${email || '—'}`,
      `items requested: ${requests.map(r => `${r.handle}:${r.variantId}`).join(', ') || '—'}`,
      extra || ''
    ]
      .filter(Boolean)
      .join('\n');
    document.body.appendChild(panel);
  };

  if (!requests.length) {
    renderDebug('result: no valid items in URL');
    showError();
    return;
  }

  const normalizeImage = url => {
    if (!url) return '';
    let out = url;
    if (out.startsWith('//')) out = `https:${out}`;
    out += out.includes('?') ? '&width=192' : '?width=192';
    return out;
  };

  const buildVariantLine = variant => {
    if (!variant || !Array.isArray(variant.options)) return '';
    return variant.options
      .map(value => (value == null ? '' : String(value).trim()))
      .filter(value => value && value.toLowerCase() !== 'default title')
      .join(' · ');
  };

  const getOptionValue = (product, variant, wantedNames) => {
    const options =
      product && Array.isArray(product.options) ? product.options : [];
    for (let i = 0; i < options.length; i++) {
      const opt = options[i];
      const name = (
        typeof opt === 'string' ? opt : opt && opt.name ? opt.name : ''
      )
        .toString()
        .toLowerCase();
      if (wantedNames.includes(name)) {
        const value = variant.options && variant.options[i];
        return value ? String(value).trim() : '';
      }
    }
    return '';
  };

  const productCache = new Map();
  const fetchProduct = handle => {
    if (!productCache.has(handle)) {
      productCache.set(
        handle,
        fetch(`/products/${encodeURIComponent(handle)}.js`, {
          headers: { Accept: 'application/json' }
        })
          .then(response => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    return productCache.get(handle);
  };

  const renderCard = (item, index) => {
    const fragment = cardTemplate.content.cloneNode(true);
    const card = fragment.querySelector('.pps-product-item');
    const titleEl = fragment.querySelector('.pps-card-title');
    const variantEl = fragment.querySelector('.pps-card-variant');
    const imgEl = fragment.querySelector('.pps-card-img');

    if (titleEl) titleEl.textContent = item.title;

    if (variantEl && item.variantLine) {
      variantEl.textContent = item.variantLine;
      variantEl.classList.remove('tw-hidden');
    }

    if (imgEl && item.image) {
      imgEl.src = item.image;
      imgEl.alt = item.title;
      imgEl.removeAttribute('hidden');
    }

    if (card) {
      card.dataset.ppsIndex = String(index);
      card.dataset.ppsSku = item.sku || '';
      card.dataset.ppsType = item.productType || '';
      card.dataset.ppsTitle = item.title || '';
      card.dataset.ppsColor = item.color || '';
      card.dataset.ppsSize = item.size || '';
      card.setAttribute('aria-label', item.title || '');
    }

    productListEl.appendChild(fragment);
  };

  const isSafeUrl = url =>
    typeof url === 'string' && url.startsWith('https://');

  const getTypeformUrl = card => {
    const typeformUrls = data.typeformUrls || {};
    const productType = (card.dataset.ppsType || '').toLowerCase();
    const categoryMap = {
      apparel: typeformUrls.apparel,
      accessories: typeformUrls.accessories,
      supplements: typeformUrls.supplements,
      hardware: typeformUrls.hardware,
      footwear: typeformUrls.footwear,
      equipment: typeformUrls.equipment
    };

    for (const [category, url] of Object.entries(categoryMap)) {
      if (productType.includes(category) && isSafeUrl(url)) return url;
    }

    return isSafeUrl(typeformUrls.default) ? typeformUrls.default : null;
  };

  const selectCard = card => {
    productListEl
      .querySelectorAll('.pps-product-item')
      .forEach(el =>
        el.setAttribute('aria-checked', el === card ? 'true' : 'false')
      );
    validationMsg.classList.add('tw-hidden');
  };

  const bindSubmit = () => {
    productListEl.addEventListener('click', e => {
      const card = e.target.closest('.pps-product-item');
      if (card) selectCard(card);
    });

    productListEl.addEventListener('keydown', e => {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      const card = e.target.closest('.pps-product-item');
      if (card) {
        e.preventDefault();
        selectCard(card);
      }
    });

    submitBtn.addEventListener('click', () => {
      const selected = productListEl.querySelector(
        '.pps-product-item[aria-checked="true"]'
      );

      if (!selected) {
        validationMsg.classList.remove('tw-hidden');
        return;
      }

      const baseUrl = getTypeformUrl(selected);
      if (!baseUrl) return;

      let typeformUrl;
      try {
        typeformUrl = new URL(baseUrl);
      } catch (_) {
        return;
      }

      typeformUrl.searchParams.set('email', email);
      typeformUrl.searchParams.set('order_id', order);
      typeformUrl.searchParams.set('sku', selected.dataset.ppsSku || '');
      typeformUrl.searchParams.set(
        'product_name',
        selected.dataset.ppsTitle || ''
      );
      typeformUrl.searchParams.set(
        'product_color',
        selected.dataset.ppsColor || ''
      );
      typeformUrl.searchParams.set(
        'product_size',
        selected.dataset.ppsSize || ''
      );

      window.location.href = typeformUrl.toString();
    });
  };

  Promise.all(requests.map(req => fetchProduct(req.handle)))
    .then(products => {
      const items = requests
        .map((req, i) => {
          const product = products[i];
          if (!product || !Array.isArray(product.variants)) return null;

          const variant = product.variants.find(
            v => String(v.id) === req.variantId
          );
          if (!variant) return null;

          const variantImage =
            variant.featured_image && variant.featured_image.src;

          return {
            title: product.title || '',
            sku: variant.sku || '',
            productType: product.type || '',
            color: getOptionValue(product, variant, ['color', 'colour']),
            size: getOptionValue(product, variant, ['size']),
            variantLine: buildVariantLine(variant),
            image: normalizeImage(variantImage || product.featured_image || '')
          };
        })
        .filter(item => item && item.title);

      renderDebug(`resolved: ${items.length}`);

      if (!items.length) {
        showError();
        return;
      }

      items.forEach(renderCard);
      showSurvey();
      bindSubmit();
    })
    .catch(err => {
      renderDebug(`error: ${err}`);
      showError();
    });
});
